import { render, staticRenderFns } from "./synonyms-form.view.vue?vue&type=template&id=6f9ff0d1&scoped=true"
import script from "./synonyms-form.view.vue?vue&type=script&lang=ts"
export * from "./synonyms-form.view.vue?vue&type=script&lang=ts"
import style0 from "./synonyms-form.view.vue?vue&type=style&index=0&id=6f9ff0d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9ff0d1",
  null
  
)

export default component.exports